export type ColorShade =
    | "0"
    | "1"
    | "2"
    | "3";

export type ColorName =
    | "green"
    | "purple"
    | "orange"
    | "blue"
    | "red";

export class Colors {

    private _colors: { [name: string]: string } = {};

    private _names: ColorName[] = [
        "green",
        "purple",
        "orange",
        "blue",
        "red"
    ];

    private _shades: ColorShade[] = [
        "0",
        "1",
        "2",
        "3"
    ];

    public constructor() {
        const root = window.getComputedStyle(document.documentElement);
        for (let name of this._names) {
            for (let shade of this._shades) {
                this._colors[this.getPropertyName(name, shade)] = root.getPropertyValue(this.getCssName(name, shade));
            }
        }
    }

    public fromIndex(index: number, shade: ColorShade = "1") {
        const name = this._names[index];
        if (!name) {
            return null;
        }
        return this.fromName(name, shade);
    }

    public fromName(name: ColorName, shade: ColorShade = "1"): string {
        return this._colors[this.getPropertyName(name, shade)];
    }

    public getCssName(name: ColorName, shade: ColorShade = "1"): string {
        return "--color__" + name + "--" + shade;
    }

    private getPropertyName(name: ColorName, shade: ColorShade): string {
        return name + "_" + shade;
    }

    public getAll(): string[] {
        let colors: string[] = [];
        for (let shade of this._shades) {
            for (let name of this._names) {
                colors.push(this.fromName(name, shade));
            }
        }
        return colors;
    }
}